export interface User_Interface {
  id:number,
  name:string,
  password:string,
  familly:string,
  username:string,
  type_title:string,
  persianDate:string,
  ip:string,
  creater:string,
  fname:string,
  lname:string,
  phone:string,
  type:number,
  funds:number,
  person_id:number,
  cutomer_id:number,
  expert_calibration:boolean,
  del:boolean,
  DeletingProccess:boolean,
}

export function Empty_User_Interface():User_Interface{
  return{
    id:0,
    name:'',
    password:'',
    familly:'',
    username:'',
    type_title:'',
    persianDate:'',
    ip:'',
    creater:'',
    fname:'',
    lname:'',
    phone:'',
    type:0,
    funds:0,
    person_id:0,
    cutomer_id: 0,
    del:false,
    expert_calibration:false,
    DeletingProccess:false,
  }
}
